import React, { Component } from "react"
import { Container, Row, Col } from "reactstrap"
import { withTranslation } from 'react-i18next'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


// Import des 4 pictos
import picto1 from "../../images/home/Kit-concu-prepare-et-analyse-en-laboratoire-en-France.png"
import picto2 from "../../images/home/Analyse-confidentielle-microbiote-nahibu.png"
import picto3 from "../../images/home/Sequencage-metagenomique-shotgun.png"
import picto4 from "../../images/home/Accompagnement-humain.png"

class MetagenomiqueViePrivee extends Component {
  render() {
    const { t } = this.props

    const pictos = [
      { img: picto1, text: t("home|Kit conçu, préparé et analysé en laboratoire en France.") },
      { img: picto2, text: t("home|Analyse confidentielle, 100% conforme au RGPD") },
      { img: picto3, text: t("home|Séquençage métagénomique shotgun, fiable et complet") },
      { img: picto4, text: t("home|Accompagnement humain") }
    ]

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000
    }

    return (
      <div className='px-3 px-md-0'>
        <Container className='my-5 py-0 py-md-5'>
          <h2 className='mb-5 second-title dark-blue text-left text-md-center'>{t("home|Métagénomique et vie privée")}</h2>
          <Row>
            <Col md={4} className='margin-auto'>
              <Slider {...settings}>
                {pictos.map((picto, index) => (
                  <div key={index} className='text-center'>
                    <img
                    alt={picto.text}
                    src={picto.img}
                    style={{
                        width: "100%",
                        maxWidth: "200px",
                        maxHeight: "150px",
                        margin: "0 auto",
                        display: "block",
                        objectFit: "contain"
                    }}
                    />
                    <p className='mt-3 small' style={{ maxWidth: "200px", margin: "0 auto" }}>
                    {picto.text}
                    </p>

                  </div>
                ))}
              </Slider>
            </Col>
            <Col md={8} className='margin-auto text-justify pt-5'>
              <p className='mb-2'>{t("home|RGPD-1")}</p>
              <p className='mb-2'>{t("home|RGPD-2")}</p>
              <p className='mb-2'>{t("home|RGPD-3")}</p>
              <p className='mb-2'>{t("home|RGPD-4")}</p>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default withTranslation()(MetagenomiqueViePrivee)
